import { API } from "aws-amplify";
import { recommendToUser, verifySkill } from "@/graphql/mutations";
import { sendRecommendToUser } from "@/hooks/useRecommendation";
import { UtilsUsecase } from "./types";

export async function skillRecommendationsUsecase(payload: any, utils: UtilsUsecase) {
  try {
    await API.graphql({
      query: recommendToUser,
      variables: payload,
    });
    await utils.refetch();
    utils.successModal({
      show: true,
      title:
        payload?.purpose === "DECLINED"
          ? "Skill Recommendation Declined"
          : payload?.type === "SKILL"
          ? "Skill Added"
          : "Skill ladder added",
      body:
        payload?.purpose === "DECLINED"
          ? "You successfully declined the recommended skill."
          : payload?.type === "SKILL"
          ? "1 Skill added to your goals"
          : "1 Skill ladder added to your goals",
    });
  } catch (error: any) {
    utils.errorModal({
      title: "Error",
      body:
        error?.errors?.[0]?.message ||
        `${payload?.purpose?.toLocaleLowerCase()} ${payload?.type?.toLocaleLowerCase()} failed to process, please try again`,
      show: true,
      type: "error",
    });
  }
}

export async function skillVerificationRequestUsecase(payload: any, utils: UtilsUsecase) {
  if (payload?.purpose === "ACCEPTED") {
    utils?.router?.push(
      {
        pathname: utils?.router.pathname,
        query: {
          m: "verify-skill",
          data: JSON.stringify(payload),
        },
      },
      undefined,
      { shallow: true }
    );
    return;
  }

  try {
    await API.graphql({
      query: verifySkill,
      variables: {
        targetUserID: payload?.targetUserID,
        targetObjectID: payload?.targetObjectID,
        rateValue: payload?.rateValue,
        purpose: payload?.purpose,
      },
    });

    if (payload?.purpose === "DECLINED") {
      utils?.successModal({
        show: true,
        title: "Skill Verification Declined",
        body: `You have successfully Declined to verify this Skill.`,
      });
    } else {
      utils?.successModal({
        show: true,
        title: "Skill Verification Success",
        body: `You have successfully verified this Skill.`,
      });
    }
  } catch (error: any) {
    utils?.errorModal({
      title: "Error",
      body:
        error?.errors?.[0]?.message ||
        `${payload?.purpose?.toLocaleLowerCase()} skill verify failed, please try again`,
      show: true,
      type: "error",
    });
  }
}

